import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import Button from "../../components/button/button";
import "./sponsorsAll.css";
import "../../index.css";
import PopUpModal from "../../popUpForms/formModals/popUpFormModal";
import PopUpFormSponsor from "../../popUpForms/popUpFormSponsor";

function SponsorsPage() {
  const [formActiveState, setFormActiveState] = useState(false);
  const [isOpen, setIsOpen] = useState({
    profitability: false,
    innovation: false,
    industry: false,
    strategic: false,
    modalOpen: false, // State for modal visibility
  });

  const toggleDropdown = (section) => {
    setIsOpen((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const toggleModal = () => {
    setFormActiveState(true);
  };

  return (
    <>
    <Helmet>
      <title>Sponsor Wildfire Prevention | CWPC</title>

      <meta
        name="description"
        content="Support CWPC efforts in wildfire prevention, community safety, and resilience through sponsorship."
      />

      <link
        rel="canonical"
        href="https://preventwildfire.world/sponsor"
      />

      <meta property="og:type" content="website" />
      <meta
        property="og:site_name"
        content="Catastrophic Wildfire Prevention Consortium"
      />

      <meta
        property="og:title"
        content="Sponsor Wildfire Prevention | CWPC"
      />

      <meta
        property="og:description"
        content="Partner with CWPC to support wildfire prevention and community resilience."
      />

      <meta
        property="og:url"
        content="https://preventwildfire.world/sponsor"
      />

      <meta
        property="og:image"
        content="https://preventwildfire.world/assets/og-default.jpg"
      />
    </Helmet>
    <div className="sponsor-page">
      <div className="section-hero">
        <div className="section-content-container large-screen-limit">
          <h1 className="hero-text">Be Part of the Solution</h1>
          <h4 className="hero-text">
            Accelerate innovation and protect communities worldwide
          </h4>
          <Button text="Join CWPC" color="var(--orange)" link="/contact-us" />
        </div>
      </div>
      <section className="text-white" id="section-experience-benefits">
        <p>
          Climate-driven wildfires are ravaging the United States, inflicting a
          massive economic toll of $394 to $893 billion each year – a
          catastrophic cost that ripples through every corner of our economy and
          threatens countless American communities.
        </p>
        <p>
          We believe that collaborative action is essential for effective
          wildfire mitigation and climate change solutions. The Catastrophic
          Wildfire Prevention Consortium (CWPC) Sponsor Program invites diverse
          stakeholders—including insurers, investors, technologists, innovators,
          policymakers, and community leaders—to accelerate cutting-edge
          solutions and drive meaningful change.
        </p>
        <p>
          Join us now to accelerate our future and make a lasting impact in an
          increasingly fire-prone world. The time for collective action is now.
          Are you ready to be part of the solution?
        </p>
        <h2 className="text-green header-title">Experience the Benefits</h2>
        <p>
          Discover the advantages of our Sponsor program, designed to enhance
          community resilience, reduce wildfire risks, and to foster
          collaboration among stakeholders.
        </p>
        <div className="sponsor-dropdown">
          <div className="dropdown-wrapper">
            <h5 onClick={() => toggleDropdown("profitability")}>
              Profitability – Business{" "}
              <span>
                Benefits{" "}
                <i
                  className={`fa-solid fa-circle-plus fa-md ${
                    isOpen.profitability ? "open" : ""
                  }`}
                ></i>
              </span>
            </h5>
            {isOpen.profitability && (
              <p className="dropdown-text" id="sponsor-profitability">
                Implementing prevention and integrated mitigation strategies
                reduces wildfire-related costs, increasing profits for insurers,
                investors, and corporations while strengthening community
                resilience.
              </p>
            )}
          </div>

          <div className="dropdown-wrapper">
            <h5 onClick={() => toggleDropdown("innovation")}>
              Innovation and Early{" "}
              <span>
                Access{" "}
                <i
                  className={`fa-solid fa-circle-plus fa-md ${
                    isOpen.innovation ? "open" : ""
                  }`}
                ></i>
              </span>
            </h5>
            {isOpen.innovation && (
              <p className="dropdown-text" id="sponsor-innovation">
                Gain early access to new opportunities and innovative solutions,
                fostering connections with emerging innovators.
              </p>
            )}
          </div>

          <div className="dropdown-wrapper">
            <h5 onClick={() => toggleDropdown("industry")}>
              Industry Leader: Community and Corporate Social{" "}
              <span>
                Responsibility{" "}
                <i
                  className={`fa-solid fa-circle-plus fa-md ${
                    isOpen.industry ? "open" : ""
                  }`}
                ></i>
              </span>
            </h5>
            {isOpen.industry && (
              <p className="dropdown-text" id="sponsor-industry">
                Drive comprehensive wildfire resilience through strategic CSR
                initiatives that enhance community safety, ensure business
                continuity, and demonstrate industry leadership in environmental
                and social responsibility.
              </p>
            )}
          </div>

          <div className="dropdown-wrapper">
            <h5 onClick={() => toggleDropdown("strategic")}>
              Strategic Relationship Building & Networking{" "}
              <span>
                {" "}
                Opportunities{" "}
                <i
                  className={`fa-solid fa-circle-plus fa-md ${
                    isOpen.strategic ? "open" : ""
                  }`}
                ></i>
              </span>
            </h5>
            {isOpen.strategic && (
              <p className="dropdown-text" id="sponsor-strategic">
                Join weekly workshops with global experts and innovators to
                develop wildfire mitigation solutions, and showcase your
                breakthrough ideas at events like the Wildfire Innovator
                Showcase.
              </p>
            )}
          </div>
        </div>
        {/* Modal Trigger Button */}
        <Button
          onClick={toggleModal}
          color="var(--orange)"
          text="Become a Sponsor"
        />
      </section>
      <div id="sponsor-package">
        <section className="section">
          <h2 className="text-gold header-title">Sponsor Package</h2>
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th className="text-orange">
                    <h4>Offerings</h4>
                  </th>
                  <th className="text-green">
                    <h4>Bronze Level ($5,000)</h4>
                  </th>
                  <th className="text-green">
                    <h4>Silver Level ($7,500)</h4>
                  </th>
                  <th className="text-green">
                    <h4>Gold Level ($25,000)</h4>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <h5>Innovator Introductions</h5>
                    <p>
                      Matched introductions to specific innovator categories and
                      companies
                    </p>
                  </td>
                  <td></td>
                  <td></td>
                  <td className="table-check-box">
                    <i className="fa-solid fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>Executive Roundtable</h5>
                    <p>
                      Meet with cross-industry executive working to invest in &
                      prevent wildfires
                    </p>
                  </td>
                  <td></td>
                  <td></td>
                  <td className="table-check-box">
                    <i className="fa-solid fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>Strategic Relationship Building</h5>
                    <p>
                      Eligible for strategic relationship building sessions with
                      innovators and communities dealing with wildfire threats
                    </p>
                  </td>
                  <td></td>
                  <td className="table-check-box">One time a year</td>
                  <td className="table-check-box">Three times a year</td>
                </tr>
                <tr>
                  <td>
                    <h5>Event Access</h5>
                    <p>
                      Guaranteed participation at annual and quarterly events
                    </p>
                  </td>
                  <td></td>
                  <td className="table-check-box">
                    <i className="fa-solid fa-check"></i>
                  </td>
                  <td className="table-check-box">
                    <i className="fa-solid fa-check"></i>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h5>Marketing Exposure</h5>
                    <p>
                      Presence on CWPC marketing materials. Logo placement on
                      event marketing materials (exclusive social media posts
                      and verbal recognition in meetings/events)
                    </p>
                  </td>
                  <td className="table-check-box">
                    <i className="fa-solid fa-check"></i>
                  </td>
                  <td className="table-check-box">
                    <i className="fa-solid fa-check"></i>
                  </td>
                  <td className="table-check-box">
                    <i className="fa-solid fa-check"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
      <section className="text-white" id="our-accomplishments">
        <h2 className="text-cornflower-blue header-title">
          Our Accomplishments
        </h2>

        <div className="accomplishment-item">
          <div className="accomplishment-item-image-wrapper">
            <img
              src="/images/sponsors/Aldercroft-heights.jpg"
              alt="Aldercroft Heights Community Pilot"
            />
          </div>
          <div className="accomplishment-text">
            <h5 className="text-gold">Aldercroft Heights Community Pilot</h5>
            <p>
              The community secured $60,000 from SJ Water and joined a $6.7
              million watershed grant, protecting about two-thirds of their land
              perimeter.
            </p>
            <p className="space-above">
              The initiative introduced start-up Delphire to pilot their
              advanced fire detection devices on community property.
            </p>
          </div>
        </div>

        <div className="accomplishment-item">
          <div className="accomplishment-item-image-wrapper">
            <img
              src="/images/sponsors/meeting-screenshot.png"
              alt="International Wildfire Consortium"
            />
          </div>
          <div className="accomplishment-text">
            <h5 className="text-gold">International Wildfire Consortium</h5>
            <p>
              The Consortium has fostered extensive networking and collaboration
              among over 100 organizations globally, leading to multi-million
              dollar grant applications and strong presence across countries
              such as Australia, New Zealand, Brazil, Canada, USA, Germany,
              Spain, UK etc.
            </p>
          </div>
        </div>

        <div className="accomplishment-item">
          <div className="accomplishment-item-image-wrapper graph">
            <img
              src="/images/sponsors/ScorecardDetails.png"
              alt="Community Wildfire Resilience Scorecard and Web Site"
            />
          </div>
          <div className="accomplishment-text">
            <h5 className="text-gold">
              Community Wildfire Resilience Scorecard and Web Site
            </h5>
            <p>
              The Scorecard, developed in partnership with ARISE-US and the
              United Nations' Disaster Risk Reduction (UNDRR), has been launched
              globally and translated into Spanish, with pilot programs now
              being explored in Okanagan, Washington, and California to
              strengthen wildfire resilience.
            </p>
          </div>
        </div>
      </section>
      <section id="explore-opportunities">
        <h2 className="header-title">Explore Opportunities with Us</h2>
        <h5>Wildfire Innovators Showcase</h5>
        <p>
          The Wildfire Innovators Showcase is a partnership between{" "}
          <a
            href="https://www.venturestarters.com"
            target="_blank"
            rel="noreferrer"
          >
            Venture Starters
          </a>{" "}
          and the <a href="/">Catastrophic Wildfire Prevention Consortium</a>,
          features international presentations from pioneering wildfire solution
          developers.
        </p>
        <p>
          Since its launch, the program has drawn over 500 live attendees and
          10,000 registrants in two years.
        </p>
        <h5>Innovator Presentations / Demonstrations</h5>
        <p>
          CWPC hosts weekly innovator meetings on{" "}
          <a href="/scorecard/subscribe">Wednesdays 12pm PST (Subscribe)</a>,
          where attendees will be provided the opportunity to explore
          cutting-edge solutions and networking among innovators. Online
          gatherings allow for deeper insights and exchanges into each
          innovation and its potential impact on wildfire resilience.
        </p>
      </section>
      <section id="who-we-are">
        <h2 className="text-orange header-title">Who we are</h2>
        <div className="header-with-icon">
          <h5>Catastrophic Wildfire Prevention Consortium (CWPC)</h5>
          <img src="/images/sponsors/newlogo3.svg" alt="SVG Icon" />
        </div>
        <p>
          The Catastrophic Wildfire Prevention Consortium (CWPC) is an
          international group of experts, institutions, and volunteers dedicated
          to reducing catastrophic wildfire risk through innovative prevention
          strategies. We aim to transform potential costs of inaction into
          funding for proactive impact. Our approach combines new and
          traditional methods to make communities safer, resilient, and
          regenerative.
        </p>
        <p>
          CWPC provides a platform for leaders to drive impact in wildfire
          prevention, creating an ecosystem that prioritizes safety and
          progress. By partnering with us, you can be at the forefront of
          transformative change in wildfire management.
        </p>
      </section>

      <PopUpModal
        activeForm="sponsor"
        formActiveState={formActiveState}
        setFormActiveState={setFormActiveState}
      >
        <PopUpFormSponsor />
      </PopUpModal>
    </div>
    </>
  );
}

export default SponsorsPage;
